<template lang="html">
    <el-row>
        <list-template :queryParams="queryParams" actionUrl="privateUsedCar/findPrivateUsedCarList.action"
                       ref="list-template">

            <template slot="search">

                <el-row :gutter="5">
                    <el-col :span="2">
                        <channel-select @change="channelIdsChange" clearable filterable placeholder="渠道来源"
                                        ref="channelSelect" v-belong-to-admin></channel-select>
                    </el-col>

                    <el-col :span="2">
                        <el-select @change="onStatusChange" clearable placeholder="上架状态" v-model="queryParams.opStatus">
                            <el-option :value="3" label="待审核"></el-option>
                            <el-option :value="1" label="已上架"></el-option>
                            <el-option :value="0" label="未上架"></el-option>
                        </el-select>
                    </el-col>

                    <el-col :span="2">
                        <el-select @change="onCreateModeChange" clearable placeholder="删除状态" v-model="queryParams.del">
                            <el-option :value="0" label="未删除"></el-option>
                            <el-option :value="1" label="已删除"></el-option>
                        </el-select>
                    </el-col>

                    <el-col :span="2">
                        <el-select @change="onTopFlagChange" clearable placeholder="顶置状态" v-model="queryParams.topFlag">
                            <el-option :value="0" label="未顶置"></el-option>
                            <el-option :value="1" label="已顶置"></el-option>
                        </el-select>
                    </el-col>

                    <el-col :span="3.5">
                        <el-input placeholder="用户手机/车名/商家名" v-model="queryParams.keyword"></el-input>

                    </el-col>
                    <el-col :span="3">
                        <usedCarSingleSelect :channelId="queryParams.channelId" @selectedValue="setUsedCarSingleInfoId"
                                             ref="usedCarSingleSelect"></usedCarSingleSelect>
                    </el-col>
                    <el-col :span="2">
                        <el-date-picker @change="onCreateTimeChange" end-placeholder="创建结束时间" size="large"
                                        start-placeholder="创建起始时间"
                                        type="daterange" v-model="queryParams.createTime">
                        </el-date-picker>
                    </el-col>

                </el-row>
                <el-row :gutter="2">
                    <el-col :span="1.5">
                        <el-button @click="$refs['list-template'].search()" size="small" type="primary">搜索</el-button>
                    </el-col>
                    <el-col :span="1.5">
                        <el-button @click="excelExport()" size="small" type="warning" v-belong-to-admin>导出</el-button>
                    </el-col>
                    <el-col :span="1.5">
                        <el-button @click="$router.push({name:'发布二手车'})" size="small" type="warning">发布二手车</el-button>
                    </el-col>
                    <el-col :span="1">
                        <el-button @click="showAuthPhone" size="small" type="warning" >审核机制设置
                        </el-button>
                    </el-col>

                </el-row>
            </template>
            <template slot-scope="scope" slot="item">
                <el-card class="basic-margin" v-bind:key="index" v-for="(data,index) in scope.datas">
                    <el-row>
                        <el-col :span="3">
                            <img :src="imageUrl+data.photo.split(',')[0]" style="width:150px;height:100px;"
                                 v-if="data.photo">
                        </el-col>

                        <el-col :span="14">
                            <p>
                                <span style="margin-left:0px;"><strong>{{data.sellingPrice/1000000}} 万元 | {{data.fullName}}</strong></span>
                                <span style="margin-left:6px;">
                                    <el-tag size="small" type="warning" v-if="data.authStatus == 1">待审核</el-tag>
                                    <el-tag size="small" type="success" v-if="data.authStatus == 2">已通过</el-tag>
                                    <el-tag size="small" type="danger" v-if="data.authStatus == 3">未通过</el-tag>

                                  </span>
                                <span style="margin-left:6px;">
                                    <el-tag size="small" type="success" v-if="data.status == 1">已上架</el-tag>
                                    <el-tag size="small" type="danger" v-if="data.status == 0">未上架</el-tag>

                               </span>
                                <span style="margin-left:6px;" v-if="data.topFlag==1"><el-tag size="small"
                                                                                              type="warning">置顶</el-tag></span>
                                <span style="margin-left:6px;">
                                       <el-tag size="small" type="danger" v-if="data.del == 1">已删除</el-tag>
                                       <el-tag size="small" type="success" v-if="data.del == 2">未删除</el-tag>
                                  </span>
                                <span style="margin-left:6px;">  <el-tag size="small">{{data.browseCount}} 次浏览 | {{data.callPhoneCount}} 人次拨打</el-tag></span>
                                <span style="margin-left:6px;" v-if="data.cloudMasterBusinessName">  <el-tag
                                        size="small">{{data.cloudMasterBusinessName}}</el-tag></span>
                            </p>

                            <p>{{data.licenseTime|yearFormat}} 年 | {{data.mileage}} 万公里 | {{data.licenseAddress}} |
                                新车价：{{(data.officePrice/1000000).toFixed(2)}} 万</p>

                            <p><span style="color:red;">{{data.releasePersonPhone}}</span>
                                {{data.releasePersonName}}（登录账号：{{data.loginPhone}}）</p>

                            <p>{{data.createTime | dateTimeFormat}} 发布于 {{data.channelName}}</p>
                        </el-col>

                        <el-col :span="6" style="text-align:right;">

                            <el-button
                                    @click.native.prevent="showAuthStatus(data.id)"
                                    type="text"
                                    v-if="data.authStatus == 1 "
                            >
                                审核
                            </el-button>

                            <el-button :confirm-data="{id:data.id,status:data.status==1?0:1}"
                                       :confirm-text="data.status==1?'确认下架该商品？':'确认上架该商品？'"
                                       :style="{color:data.status==1?'#f56c6c':'#67c23a'}"
                                       @onConfirm="$refs['list-template'].search()"
                                       requestUrl="privateUsedCar/changePrivateUsedCarStatus.action"
                                       type="text"
                                       v-confirm>{{data.status==1?'下架':'上架'}}
                            </el-button>

                            <el-button :confirm-data="{id:data.id,del:1}"
                                       :confirm-text="data.status==1?'确认删除该商品？':'确认删除该商品？'"
                                       :style="{color:data.status==1?'#f56c6c':'#67c23a'}"
                                       @onConfirm="$refs['list-template'].search()"
                                       requestUrl="privateUsedCar/delPrivateUsedCar.action"
                                       type="text" v-confirm>删除
                            </el-button>
                            <el-button :style="{color:data.status==1?'#f56c6c':'#67c23a'}" @click="$router.push({name:'发布二手车',query:{id:data.id}})"
                                       type="text">修改
                            </el-button>
                            <el-button :style="{color:data.status==1?'#f56c6c':'#67c23a'}" @click="openHandTopDialog(data)"
                                       type="text">置顶
                            </el-button>
                        </el-col>

                    </el-row>
                </el-card>
            </template>

        </list-template>

        <el-dialog :visible.sync="dialogFormVisible" title="置顶">
            <el-form :model="usedCarForm">
                <el-form-item label="置顶结束时间">
                    <el-date-picker
                            placeholder="选择日期时间"
                            type="datetime"
                            v-model="usedCarForm.endDateTime"
                            value-format="timestamp">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div class="dialog-footer" slot="footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button @click="handTop" type="primary">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogWhitePhoneFormVisible" title="白名单">
            <el-form :model="whitePhoneForm">

                <el-form-item label="用户账号" label-width="120px">
                    <el-input :readonly="whitePhoneForm.isUpdate" placeholder="请输入用户11位手机账号"
                              v-model="whitePhoneForm.phone"></el-input>
                </el-form-item>

                <el-form-item label="限每日免费发布" label-width="120px">
                    <el-input placeholder="限每日免费发布(条)" v-model="whitePhoneForm.count"></el-input>
                </el-form-item>

            </el-form>
            <div class="dialog-footer" slot="footer">
                <el-button @click="dialogWhitePhoneFormVisible = false">取 消</el-button>
                <el-button @click="saveWhitePhone" type="primary">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogAuthStatusFormVisible" title="您正在操作二手车信息审核！" width="30%">

            <el-form :model="dialogAuthStatusForm" label-width="160px" ref="dialogAuthStatusForm"
                     style="margin-left:20px;">
                <el-radio-group v-model="dialogAuthStatusForm.authStatus">
                    <el-radio :label="2">审核通过</el-radio>
                    <div style="height:20px;"></div>
                    <el-radio :label="3">审核不通过</el-radio>
                </el-radio-group>

                <el-input :rows="2" @input="isSendInfo()" placeholder="请输入操作理由"
                          style="margin-left:30px;width:80%" type="textarea" v-model="dialogAuthStatusForm.remark"></el-input>

                <div style="margin-left:30px;width:80%">
                    <el-checkbox @change="isSendInfo()" style="" v-model="dialogAuthStatusForm.isSend">发送短信
                    </el-checkbox>
                    <span style="color:red;">{{dialogAuthStatusForm.sendInfo}}</span>
                </div>
            </el-form>
            <div class="dialog-footer" slot="footer">

                <el-button @click="authStatus()" type="primary">确认无误</el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogAuthFormVisible" title="审核机制设置">

            <el-form :model="configForm" label-width="160px" ref="configForm" style="margin-left:20px;">
                <h3>二手车人工审核</h3>
                <el-radio-group @change="updateUsedCarAuthSwitch()" v-model="configForm.usedCarAuthSwitch">
                    <el-radio :label="1">都不审核</el-radio>
                    <el-radio :label="2">仅免费发布审核</el-radio>
                    <el-radio :label="3">全部审核</el-radio>
                </el-radio-group>

            </el-form>
            <h3 style="margin-left:20px;">二手车发布白名单</h3>
            <div style="margin-left:20px;">以下白名单用户，发布二手车信息不需要审核</div>
            <div style="margin-left:20px;margin-top:10px">
                <el-button @click="openAuthFormDialog()" size="medium" type="primary">添加白名单</el-button>
            </div>
            <div>
                <el-table :data="whitePhoneData">
                    <el-table-column label="手机号" property="phone" width="150"></el-table-column>
                    <el-table-column label="限每日免费发布(条)" property="count" width="200"></el-table-column>
                    <el-table-column label="时间" property="createTime" width="200"></el-table-column>
                    <el-table-column label="操作">
                        <template  slot-scope="scope">
                            <el-button @click="updatePrivateUsedCarWhite(scope.row)" type="text">修改</el-button>
                            <el-button @click="deletePrivateUsedCarWhite(scope.row.id)" type="text">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-pagination :current-page.sync="currentPage" :page-size="pageSize" :total="total"
                               class="basic-margin" layout="total, prev, pager, next">
                </el-pagination>
            </div>

        </el-dialog>

    </el-row>

</template>

<script>
import ListTemplate from '@/components/ListTemplate'
import BasicPager from '@/mixins/BasicPager'
import channelSelect from '@/components/channelSelect'
import usedCarSingleSelect from '@/components/usedCarSingleSelect'
import usedCarModel from '@/framework/models/usedCarModel'
import Config from '@/framework/configs/Config'

export default {
  name: 'private-car-management',
  extends: BasicPager,
  data: function () {
    return {
      whitePhoneData: [],
      total: 0,
      pageSize: 10,
      currentPage: 0,
      imageUrl: Config.imageUrl,
      isAdmin: false,
      dialogFormVisible: false,
      dialogWhitePhoneFormVisible: false,
      dialogAuthFormVisible: false,
      dialogAuthStatusFormVisible: false,
      queryParams: {
        channelId: null,
        createMode: null,
        createTime: '',
        startTime: null,
        endTime: null,
        keyword: '',
        status: null,
        opStatus: null,
        authStatus: null,
        type: null,
        viewStatus: [],
        usedCarSingleInfoId: null,
        topFlag: null,
        del: 0
      },
      configForm: {
        usedCarAuthSwitch: 1
      },
      dialogAuthStatusForm: {
        id: null,
        authStatus: 2,
        isSend: true,
        sendInfo: '',
        remark: null
      },
      whitePhoneForm: {
        phone: null,
        count: null,
        isUpdate: false,
        whitePhoneListId: null
      },
      usedCarForm: {
        id: null,
        endDateTime: null
      }
    }
  },
  components: {
    ListTemplate,
    channelSelect,
    usedCarSingleSelect
  },
  filters: {
    statusFilter: function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 2:
          str = '已下架'
          break
        case 1:
          str = '已上架'
          break
        default:
          str = '暂无'
      }

      return str
    },
    authStatusFilter: function (valueFilter) {
      let str = ''
      switch (valueFilter) {
        case 2:
          str = '已通过'
          break
        case 1:
          str = '待审核'
          break
        case 3:
          str = '拒绝通过'
      }

      return str
    }
  },
  created: function () {
    let status = this.$route.query.status
    if (status === 3) {
      this.queryParams.status = null
      this.queryParams.authStatus = 1
      this.queryParams.opStatus = 3
    }
    if (this.loginInfo.loginPath === 'channel') {
      this.queryParams.channelId = this.loginInfo.id
    }

    let userInfo = JSON.parse(localStorage.userInfo)
    this.isAdmin = userInfo.loginPath !== 'channel'
  },

  activated: function () {
    this.$refs['list-template'].loadList()
  },
  methods: {

    isSendInfo: function () {
      if (this.dialogAuthStatusForm.isSend && this.dialogAuthStatusForm.remark) {
        this.dialogAuthStatusForm.sendInfo = '很抱歉，您发布的二手车未通过：' + this.dialogAuthStatusForm.remark
      } else {
        this.dialogAuthStatusForm.sendInfo = ''
      }
    },
    saveWhitePhone: function () {
      let _this = this
      let phone = this.whitePhoneForm.phone
      if (!phone) {
        _this.$message({
          message: '手机号不能为空！',
          type: 'error'
        })
        return
      }
      if (phone.length > 15) {
        _this.$message({
          message: '手机号最多15位！',
          type: 'error'
        })
        return
      }

      let count = this.whitePhoneForm.count + ''
      if (!count) {
        _this.$message({
          message: '免费次数不能为空！',
          type: 'error'
        })
        return
      } else {
        var r = new RegExp('^[0-9]*$')
        if (!r.test(this.whitePhoneForm.count)) {
          _this.$message({
            message: '请输入数字！',
            type: 'error'
          })
          return
        }
      }

      let userInfo = this.getLoginInfo()
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      }

      let param = { id: id, phone: phone, count: count, whitePhoneListId: this.whitePhoneForm.whitePhoneListId }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.$message({
              message: '添加成功！',
              type: 'success'
            })
            _this.dialogWhitePhoneFormVisible = false
            _this.loadAuthPhoneList()
          } else {
            _this.$message({
              message: dataInfo.errMsg,
              type: 'error'
            })
          }
        }
      }
      usedCarModel.saveOrUpdateWhitePhone(_this, param, listener)
    },
    deletePrivateUsedCarWhite: function (id) {
      this.$confirm('确定删除白名单', '白名单！', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let _this = this
        let param = { 'id': id }
        let listener = {
          success: function (dataInfo) {
            if (dataInfo.success) {
              _this.$message({
                message: '刪除成功！',
                type: 'success'
              })
              _this.loadAuthPhoneList()
            } else {
              _this.$message({
                message: '刪除失败！',
                type: 'error'
              })
            }
          }
        }
        usedCarModel.deletePrivateUsedCarWhite(_this, param, listener)
      }).catch(() => {

      })
    },
    updatePrivateUsedCarWhite: function (data) {
      this.dialogWhitePhoneFormVisible = true
      this.whitePhoneForm.isUpdate = true
      this.whitePhoneForm.whitePhoneListId = data.id
      this.whitePhoneForm.count = data.count
      this.whitePhoneForm.phone = data.phone
    },
    updateUsedCarAuthSwitch: function () {
      let userInfo = this.getLoginInfo()
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      }
      let _this = this
      let param = { 'id': id, 'usedCarAuthSwitch': this.configForm.usedCarAuthSwitch }
      let listener = {
        success: function (dataInfo) {
          if (dataInfo.success) {
            _this.$message({
              message: '修改成功！',
              type: 'success'
            })
          } else {
            _this.$message({
              message: '修改失败！',
              type: 'error'
            })
          }
        }
      }
      usedCarModel.changeChannelConfigAuthSwitch(_this, param, listener)
    },
    loadAuthPhoneList: function () {
      let userInfo = this.getLoginInfo()
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      }
      let _this = this
      let param = {
        id: id,
        pageNum: _this.currentPage

      }
      let listener = {
        success: function (dataInfo) {
          _this.whitePhoneData = dataInfo.data
          _this.total = dataInfo.recordsTotal
        }
      }
      usedCarModel.findPrivateUsedCarWhiteList(_this, param, listener)
    },
    showAuthPhone: function () {
      this.dialogAuthFormVisible = true
      let _this = this
      let userInfo = this.getLoginInfo()
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      }

      let param = { 'id': id }
      let listener = {
        success: function (dataInfo) {
          _this.configForm.usedCarAuthSwitch = dataInfo.datas.usedCarAuthSwitch
        }
      }
      usedCarModel.getChannelConfig(_this, param, listener)
      this.loadAuthPhoneList()
    },
    showAuthStatus: function (id) {
      this.dialogAuthStatusFormVisible = true
      this.dialogAuthStatusForm.id = id
      this.dialogAuthStatusForm.remark = null
      this.dialogAuthStatusForm.sendInfo = null
      this.dialogAuthStatusForm.isSend = true
    },
    authStatus: function () {
      let _this = this
      let param = { 'id': this.dialogAuthStatusForm.id, 'authStatus': this.dialogAuthStatusForm.authStatus }
      if (this.dialogAuthStatusForm.authStatus === 3 && this.dialogAuthStatusForm.isSend) {
        if (!this.dialogAuthStatusForm.remark) {
          _this.$message({
            message: '不通过理由不能为空！',
            type: 'error'
          })
          return
        }
        param.sendInfo = this.dialogAuthStatusForm.remark
      } else {
        param.sendInfo = null
      }

      let listener = {
        success: function (dataInfo) {
          _this.dialogAuthStatusFormVisible = false
          _this.$refs['list-template'].search()
        }
      }
      usedCarModel.changePrivateUsedCarAuthStatus(_this, param, listener)
    },
    openHandTopDialog: function (data) {
      this.usedCarForm.id = data.id
      if (data.sortTime) {
        this.usedCarForm.endDateTime = data.sortTime
      } else {
        this.usedCarForm.endDateTime = null
      }
      this.dialogFormVisible = true
    },
    openAuthFormDialog: function () {
      this.dialogWhitePhoneFormVisible = true
      this.whitePhoneForm.isUpdate = false
      this.whitePhoneForm.whitePhoneListId = null
      this.whitePhoneForm.count = null
      this.whitePhoneForm.phone = null
    },
    handTop: function () {
      let _this = this
      if (!this.usedCarForm.endDateTime) {
        this.usedCarForm.endDateTime = 0
      }
      let param = this.usedCarForm

      let listener = {
        success: function (dataInfo) {
          _this.$refs['list-template'].loadList()
          _this.$message({
            type: 'info',
            message: '置顶成功'
          })
          _this.dialogFormVisible = false
        }
      }
      usedCarModel.handTop(_this, param, listener)
    },
    setUsedCarSingleInfoId: function (value) {
      this.queryParams.usedCarSingleInfoId = value
      this.$refs['list-template'].search()
    },
    excelExport: function () {
      let userInfo = this.getLoginInfo()
      let loginPath = userInfo.loginPath
      let id = null
      if (userInfo.id) {
        id = userInfo.id
      } else if (userInfo.employeeId) {
        id = userInfo.employeeId
      }
      let url = Config.baseUrl + '/privateUsedCar/lcwpPrivateUsedCarExcel.action?token=' + userInfo.token + '&loginAccountId=' + id + '&loginPath=' + loginPath

      let createTime = this.queryParams.createTime
      if (createTime && createTime[0]) {
        url += '&startTime=' + createTime[0].getTime() + '&endTime=' + createTime[1].getTime()
      }
      if (this.queryParams.channelId) {
        url += '&channelId=' + this.queryParams.channelId
      }

      if (this.queryParams.status) {
        url += '&status=' + this.queryParams.status
      }
      if (this.queryParams.del) {
        url += '&del=' + this.queryParams.del
      }
      if (this.queryParams.usedCarSingleInfoId) {
        url += '&usedCarSingleInfoId=' + this.queryParams.usedCarSingleInfoId
      }
      window.open(url)
    },
    onCreateTimeChange: function () {
      let createTime = this.queryParams.createTime

      if (createTime && createTime[0]) {
        this.queryParams.startTime = createTime[0].getTime()
        this.queryParams.endTime = createTime[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }

      this.$refs['list-template'].search()
    },
    channelIdsChange: function (channelId) {
      if (channelId) {
        this.queryParams.channelId = channelId
      } else {
        this.queryParams.channelId = null
      }

      this.$refs['list-template'].search()
    },
    onStatusChange: function (value) {
      if (value === 3) {
        this.queryParams.status = null
        this.queryParams.authStatus = 1
      } else {
        this.queryParams.status = value
        this.queryParams.authStatus = null
      }

      this.$refs['list-template'].search()
    },
    onCreateModeChange: function (value) {
      if (!value) {
        delete this.queryParams.createMode
      }
      this.$refs['list-template'].search()
    },
    onTopFlagChange: function (value) {
      if (value == null) {
        delete this.queryParams.topFlag
      }
      this.$refs['list-template'].search()
    },

    onInputConfirm: function () {
      this.$refs['list-template'].search()
    }
  }
}
</script>

<style lang="css" scoped>
    .el-row {
        margin-bottom: 20px;

    }
</style>
